import { Text } from "@chakra-ui/react"

const SubTitle = ({ children, ...rest }) => {
	return (
		<Text color="#FCF3DB" fontSize={['12px', null, '18px']} {...rest}>
			{children}
		</Text>
	)
}

export default SubTitle
